<template>
  <section class="mb-5">
    <div class="mt-2 mb-4 border-bottom">
      <h2 class="display-4">Die Bestellungen</h2>
      <h5>
        <strong>Insgesamt</strong>
        <span class="text-primary px-2">{{ totalColumns }}</span>Bestellungen auf<span class="text-primary px-2">{{ orderPages
        }}</span>Seite/n
      </h5>
    </div>
    <div v-if="orders" class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
      <div v-for="(item, index) in orders" :key="index" class="col">
        <div class="card h-100 bg-light">
          <div class="card-header bg-dark text-white small">
            <i class="fa-solid fa-sm fa-mobile-screen-button text-primary"></i>
            {{ item.marker }} {{ item.series }} {{ item.name }}
          </div>
          <div class="card-body">
            <h5 class="card-title text-primary">
              {{ item.firstname + " " + item.lastname }}
            </h5>
            <h6 class="card-subtitle mb-2 text-muted">
              <a :href="'tel:' + item.phonenumber" :title="'Call: ' + item.firstname" class="card-link text-muted">{{
              item.phonenumber }}</a>
            </h6>
          </div>
          <div class="card-body d-flex align-items-start flex-column">
            <div class="form-text">Art dem Vorgehen:</div>
            <p class="card-text">{{ item.title }}</p>
            <div class="mt-auto">
              <div class="form-text col-12">Status der Bestellung:</div>
              <select class="form-select mb-2" v-model="item.orderState" aria-label="Default select example"
                :aria-describedby="'button-addon-' + index + 1">
                <option value="0">Neu</option>
                <option value="1">Angenommen</option>
                <option value="2">In Bearbeitung</option>
                <option value="3">Feedback</option>
                <option value="4">Abgesagt</option>
                <option value="5">Erledigt</option>
              </select>
              <div class="btn-group" role="group" aria-label="Basic example">
                <button class="btn btn-sm btn-outline-primary" @click="changeOrderState(item, index)" title="Speichern"
                  type="button" :id="'button-addon-' + index + 1">
                  Speichern
                  <i class="fa-solid fa-sm fa-floppy-disk ms-1"></i>
                </button>
                <button type="button" title="Mehr informationen" class="btn btn-sm btn-outline-success"
                  data-bs-toggle="modal" :data-bs-target="'#orderModal-' + index + 1">
                  Mehr info
                  <i class="fa-solid fa-sm fa-circle-info ms-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" :id="'orderModal-' + index + 1" tabindex="-1"
          :aria-labelledby="'ModalLabel-' + index + 1" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-light">
                <h5 class="modal-title d-block" :id="'ModalLabel-' + index + 1">
                  <i class="fa-solid fa-sm fa-user text-primary"></i>
                  {{ item.firstname + " " + item.lastname }}
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body px-3">
                <div class="d-flex flex-column border-bottom pb-1 mb-2">
                  <h5 class="text-primary mt-2 fw-bold">Kontaktdaten:</h5>
                  <a :href="'tel:' + item.phonenumber" :title="'Call: ' + item.firstname"
                    class="text-decoration-none mb-1">
                    <i class="fa-solid fa-sm fa-mobile-screen-button text-primary"></i>
                    {{ item.phonenumber }}</a>
                  <a :href="'mailto:' + item.email" :title="'Send Email to: ' + item.firstname"
                    class="text-decoration-none mb-1">
                    <i class="fa-regular fa-sm fa-envelope text-primary"></i>
                    {{ item.email }}</a>
                  <span class="mb-1">
                    <i class="fa-solid fa-sm fa-location-dot text-primary"></i>
                    {{ item.street }} {{ item.housenumber }},
                    {{ item.zipcode }} {{ item.city }}
                  </span>
                </div>
                <div class="d-flex flex-column border-bottom pb-1 mb-2">
                  <h5 class="text-primary mt-2 fw-bold">Gerätedaten:</h5>
                  <div>
                    <i class="fa-solid fa-sm fa-mobile-screen-button text-primary"></i>
                    <span class="ms-2">Gerätename:
                      <strong>{{ item.marker }} {{ item.series }} {{ item.name }}</strong>
                    </span>
                  </div>
                  <div>
                    <i class="fa-solid fa-sm fa-lock text-primary"></i>
                    <span class="ms-2">Tastensperre: <strong>{{ item.password }}</strong></span>
                  </div>
                  <div>
                    <i class="fa-solid fa-sm fa-barcode text-primary"></i>
                    <span class="ms-2">IMEI Nummer: <strong>{{ item.imei }}</strong></span>
                  </div>
                  <div>
                    <i class="fa-solid fa-sm fa-sim-card text-primary"></i>
                    <span class="ms-2">SIM-Lock von: <strong>{{ item.simlock }}</strong></span>
                  </div>
                  <div>
                    <i class="fa-solid fa-sm fa-palette text-primary"></i>
                    <span class="ms-2">Farbe: <strong>{{ item.color }}</strong></span>
                  </div>
                </div>
                <div class="d-flex flex-column border-bottom pb-1 mb-2">
                  <h5 class="text-primary mt-2 fw-bold">Art dem Vorgehen:</h5>
                  <p class="">{{ item.title }}</p>
                </div>
                <div class="d-flex flex-column border-bottom pb-1 mb-2">
                  <h5 class="text-primary mt-2 fw-bold">
                    Die ausgewählten Reparaturarten:
                  </h5>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center"
                      v-for="(item, index) in item.services" :key="index">
                      {{ item.title }}
                      <span class="badge bg-primary rounded-pill">{{ item.price }}€</span>
                    </li>
                    <li class="list-group-item fw-bold mt-2 ms-auto border-0 text-muted">
                      Summe: {{ item.sum }}€
                    </li>
                  </ul>
                </div>
                <div v-if="item.customerDescription" class="d-flex flex-column border-bottom pb-1 mb-2">
                  <h5 class="text-primary mt-2 fw-bold">Kundenbemerkungen:</h5>
                  <p>{{ item.customerDescription }}</p>
                </div>
                <div class="d-flex flex-column mb-2 col-12 col-md-8">
                  <h5 class="text-primary mt-2 fw-bold">
                    Status der Bestellung:
                  </h5>
                  <div class="input-group">
                    <select class="form-select" v-model="item.orderState" aria-label="Default select example"
                      :aria-describedby="'button-addon-' + index + 1">
                      <option value="0" selected>Neu</option>
                      <option value="1">Angenommen</option>
                      <option value="2">In Bearbeitung</option>
                      <option value="3">Feedback</option>
                      <option value="4">Abgesagt</option>
                      <option value="5">Erledigt</option>
                    </select>
                    <button class="btn btn-sm btn-outline-primary" @click="changeOrderState(item, index)"
                      title="Speichern" type="button" :id="'button-addon-' + index + 1">
                      Speichern
                    </button>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                  Abbrechen
                </button>
                <button type="button" class="btn btn-outline-success" @click="exportTableToExcel(item)"
                  title="Alle Daten als Excel Datei herunterladen">
                  Herunterladen<i class="fa-solid fa-sm fa-download ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <table v-if="currentOrder" id="tableData" class="table d-none">
        <tr>
          <th>Gerätedaten</th>
          <th>Tastensperre</th>
          <th>SIM-Lock</th>
          <th>IMEI Nummer</th>
          <th>Farbe</th>
          <th>Vorgehen titel</th>
          <th>Vorname</th>
          <th>Nachname</th>
          <th>E-Mail-Adresse</th>
          <th>Telefon</th>
          <th>Adresse</th>
          <th>Anmerkungen</th>
          <th>Summe</th>
        </tr>
        <tr>
          <td>{{ currentOrder.marker }} {{ currentOrder.series }} {{ currentOrder.name }}</td>
          <td>{{ currentOrder.password }}</td>
          <td>{{ currentOrder.simlock }}</td>
          <td>{{ currentOrder.imei }}</td>
          <td>{{ currentOrder.color }}</td>
          <td>{{ currentOrder.title }}</td>
          <td>{{ currentOrder.firstname }}</td>
          <td>{{ currentOrder.lastname }}</td>
          <td>{{ currentOrder.email }}</td>
          <td>{{ currentOrder.phonenumber }}</td>
          <td>{{ currentOrder.street }} {{ currentOrder.housenumber }}, {{ currentOrder.zipcode }} {{ currentOrder.city
          }}</td>
          <td>{{ currentOrder.customerDescription }}</td>
          <td>{{ currentOrder.sum }} Euro</td>
        </tr>
        <tr>
          <td class="fw-bold">Die ausgewählten Reparaturarten</td>
        </tr>
        <tr>
          <td>Reparaturarten</td>
          <td>Preis</td>
        </tr>
        <tr v-for="(sercice, index) in currentOrder.services" :key="index">
          <td>{{ sercice.title }}</td>
          <td>{{ sercice.price }} Euro</td>
        </tr>
      </table>
    </div>
    <table v-else class="table">
      <tbody>
        <tr v-for="(item, index) in 5" :key="index">
          <th scope="row">
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </th>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex align-items-center justify-content-center my-4">
      <ul class="pagination">
        <li class="page-item" v-for="page in orderPages" :key="page">
          <button class="page-link" @click="openPage(page)">{{ page }}</button>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "Orders",

  components: {},

  data() {
    return {
      perPage: 25,
      totalColumns: 0,
      lastColumns: 0,
      orderPages: 0,
      orders: undefined,
      currentOrder: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadTheOrders();
    });
  },

  watch: {
    "$route.params.uid"() {
      this.load();
    },
  },

  methods: {
    loadTheOrders() {
      this.$store.state.modules.api
        .loadTheOrders(this.perPage, this.lastColumns)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.orders = resp.data.units;
            this.totalColumns = resp.data.total;
            this.orderPages = Math.ceil(this.totalColumns / this.perPage);
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },
    // Download Table
    exportTableToExcel(item) {
      this.currentOrder = item
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = document.getElementById("tableData");
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");
      // Specify file name
      let filename = "Bestelldaten-mobile-tech-zone.xls";
      // Create download link element
      downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = "data:" + dataType + ", " + tableHTML;
        // Setting the file name
        downloadLink.download = filename;
        //triggering the function
        downloadLink.click();
      }
      this.currentOrder = undefined
    },
    openPage(num) {
      this.lastColumns = (num - 1) * this.perPage;
      this.loadTheOrders();
    },

    changeOrderState(item, index) {
      this.$store.state.modules.api
        .changeOrderState(item)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Bestellung Status",
                message: "Status wurde zu " + item.orderState + " geändert",
              },
              2500
            );
          }
        })
        .catch((err) => { });
    },
  },
};
</script>
